import PagePlaceholder from '@/components/PagePlaceholder';

export default function IndustriesPage() {
  return (
    <PagePlaceholder
      title="Industries"
      subtitle="Different industries. Different logic. Different intelligence. See how MorphenIQ adapts to your sector."
    />
  );
}